import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AirbnbOfficialOpportunityRepositoryService extends BaseRepositoryService<
  ModelRegistry['airbnb-official-opportunity']
> {
  recordName = 'airbnb-official-opportunity';
  implementMethods = ['unloadAll'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/airbnb-official-opportunity': AirbnbOfficialOpportunityRepositoryService;
  }
}
